import { routesName, useGetAdminGetAllChannelsList, useNavigation } from "core";
import React,{ memo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Detail } from "../../templates";

const ChannelDetail = memo(() => {
  const {_navigateWithParams}=useNavigation()
  const { i18n } = useTranslation();
  const { id } = useParams();
  
  const { data,isFetching } = useGetAdminGetAllChannelsList({pageNumber:"1",pageSize:"1",channelId:id});
  
  return (
    <>
      <Detail
        isLoading={isFetching}
        type={"channel"}
        title={i18n.t("channelDetail")}
        data={data?.data}
        onClick={() => {
          _navigateWithParams(routesName.EDITCHANNEL, {
            id: id,
          });
        }}
      />
    </>
  );
});
export { ChannelDetail };
